import { render, staticRenderFns } from "./About.vue?vue&type=template&id=dc436c80&scoped=true&"
import script from "./About.vue?vue&type=script&setup=true&lang=ts&"
export * from "./About.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./About.vue?vue&type=style&index=0&id=dc436c80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc436c80",
  null
  
)

export default component.exports